//#region IMPORT
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { showLoading, closeLoading } from '../../../../Reducer/LoadingReducer';
import dayjs from 'dayjs';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import useDelete from '../../../../hooks/useDeleteN';
import { useSearch2, useSearch3, useSave1, useDelete1 } from './WOR_BASIC_02_QUERY';
import { buildSaveWorBasic02U1Requests } from './WOR_BASIC_02_Schema';
import WOR_BASIC_02 from './WOR_BASIC_02';
import ChemSearchModal from './ChemSearchModal';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import { useSave } from '../../../../hooks/useSaveN';
//#endregion

function WOR_BASIC_02F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);
  const gridRef1 = useRef();

  const [rowData1, setRowData1] = useState([]);
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRows, setDeletedRowData1] = useState([]);
  const [gongjongColumns, setGongjongColumns] = useState([]); // GetWorBasic02R1 응답 Columns (공정 동적 컬럼)
  const [chemModalOpen, setChemModalOpen] = useState(false);
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  const currentRowIndexRef1 = useRef(null);
  //#endregion

  //#region 커스텀훅
  const { validateSelection } =
    useCompanyCustDep({ requireCompany: true, requireCust: true });
  //#endregion

  //#region useEffect
  const {
    filterClick2,
    setFilterClick2,
    saveClick2,
    setSaveClick2,
    printClick2,
    setPrintClick2,
    printClick2Guideline,
    setPrintClick2Guideline,
  } = props;
  useEffect(() => {
    if (filterClick2) {
      gridRef1.current?.api?.setQuickFilter(searchInfo.searchText || '');
      setFilterClick2(false);
    }
    if (saveClick2) {
      SaveLogic1();
      setSaveClick2(false);
    }
    if (printClick2) {
      if (!validateSelection()) {
        setPrintClick2(false);
        return;
      }
      PrintLogic1();
      setPrintClick2(false);
    }
    if (printClick2Guideline) setPrintClick2Guideline(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- saveClick2 시 SaveLogic1만 호출, SaveLogic1 제외
  }, [filterClick2, setFilterClick2, saveClick2, setSaveClick2, printClick2, setPrintClick2, printClick2Guideline, setPrintClick2Guideline, searchInfo.searchText]);
  //#endregion

  //#region 쿼리
  const { refetch: Search2 } = useSearch2({
    onSuccess: (rows, columns) => {
      setRowData1(rows ?? []);
      setGongjongColumns(columns ?? []);
    },
  });

  const { refetch: Search3 } = useSearch3();

  const ResetLogic = () => {
    setRowData1([]);
    setGongjongColumns([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };

  const SearchLogic1 = async () => {
    ResetLogic();
    if (!validateSelection()) return;
    await Search2();
  };

  const { runAsync: Save1Async } = useSave1();

  const delete1 = useDelete1();
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRows,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  const { run: Save1Run } = useSave({
    requiredLabel: '변경 또는 삭제',
    getChangedRows: () =>
      (changedRowData1 || []).filter((r) => r.deleteYn !== 'Y'),
    getDeletedRows: () =>
      (deletedRows || []).map((r) => ({
        ...r,
        custCd: searchInfo.custCd || '',
      })),
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: async (rows) => {
      const mergedChanged = (rowData1 || [])
        .filter((row) =>
          rows.some(
            (r) => (r.chemSeq ?? r.no) === (row.chemSeq ?? row.no)
          )
        )
        .map((row) => {
          const c = rows.find(
            (x) => (x.chemSeq ?? x.no) === (row.chemSeq ?? row.no)
          );
          return c ? { ...row, ...c } : row;
        });
      const requests = buildSaveWorBasic02U1Requests(
        mergedChanged,
        gongjongColumns,
        {
          custCd: searchInfo.custCd || '',
          userId:
            userInfo?.userid ?? userInfo?.userId ?? userInfo?.userNo ?? '',
        }
      );
      if (!requests.length) return null;
      return Save1Async(requests);
    },
    refresh: Search2,
    reset: ResetLogic,
  });

  const SaveLogic1 = () => {
    if (!validateSelection()) return;
    Save1Run();
  };
  //#endregion

  //#region 인쇄
  const PrintLogic1 = async () => {
    dispatch(showLoading());
    try {
      if ((changedRowData1 || []).length > 0) {
        dispatch(
          showSnackbar({
            message: '데이터를 저장 후 인쇄하세요.',
            type: 'warning',
          })
        );
        dispatch(closeLoading());
        return;
      }

      const { data: response } = await Search3();
      const rawArr =
        Array.isArray(response?.Data) ? response.Data
          : Array.isArray(response?.data) ? response.data
            : Array.isArray(response) ? response
              : [];
      const isCheckYn = (v) =>
        v === 'Y' || v === 'O' || v === 'y' || v === 'o' || v === true;

      const matSeqToExtra = new Map();
      (rowData1 || []).forEach((r) => {
        const key = r.matSeq ?? r.chemSeq;
        if (key != null) {
          matSeqToExtra.set(Number(key), {
            exposureLimit:
              r.exposureLimit ?? r.twaVal ?? r.stelVal ?? '',
            remark: r.remark ?? '',
          });
        }
      });

      const tableData = rawArr.map((row) => {
        const matSeq = row.MatSeq ?? row.matSeq;
        const extra = matSeq != null ? matSeqToExtra.get(Number(matSeq)) : null;
        return {
          matSeq,
          korNm: row.KorNm ?? row.korNm ?? '',
          gongjongNm: row.GongjongNm ?? row.gongjongNm ?? '',
          checkYn: isCheckYn(row.CheckYn ?? row.checkYn) ? 'O' : '',
          exposureLimit:
            row.ExposureLimit ?? row.exposureLimit ?? extra?.exposureLimit ?? '',
          remark: row.Remark ?? row.remark ?? extra?.remark ?? '',
        };
      });

      if (!tableData.length) {
        dispatch(
          showSnackbar({
            message: '인쇄할 데이터가 없습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoading());
        return;
      }

      const headerData = {
        todayDate: dayjs().format('YYYY-MM-DD'),
      };

      const printData = {
        FileName: 'WOR_BASIC_02',
        HeaderData: JSON.stringify(headerData),
        TableData: JSON.stringify(tableData),
      };

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank');
      });
    } catch (e) {
      console.error(e);
      dispatch(
        showSnackbar({
          message: e?.message || '인쇄 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };
  //#endregion

  //#region 핸들러
  const NewYnErrorMsg = () => {
    dispatch(showSnackbar({ message: '데이터 입력중입니다. 저장 후 시도하세요.', type: 'warning' }));
  };

  const handleRowSelection1 = (rowData, rowIndex) => {
    currentRowIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  const AddClick1 = () => {
    setChemModalOpen(true);
  };

  const handleChemSelect = (rows) => {
    if (!rows?.length) return;
    const withProcess = rows.map((row) => {
      const r = { ...row };
      gongjongColumns.forEach((col) => {
        const f = col.Field ?? col.field;
        if (f) r[f] = r[f] ?? '';
      });
      return r;
    });
    setRowData1((prev) => [...prev, ...withProcess]);
    setChangedRowData1((prev) => [...prev, ...withProcess]);
  };
  //#endregion

  return (
    <div className="wrap">
      <ChemSearchModal
        open={chemModalOpen}
        onClose={() => setChemModalOpen(false)}
        onSelect={handleChemSelect}
      />
      <WOR_BASIC_02
        gridRef1={gridRef1}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        deletedRowData1={deletedRows}
        selectedRowNosRef1={selectedRowNosRef1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        validateSelection={validateSelection}
        SearchLogic1={SearchLogic1}
        RestoreRow1={deleteHandler1.RestoreRow}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        NewYnErrorMsg={NewYnErrorMsg}
        handleRowSelection1={handleRowSelection1}
        gongjongColumns={gongjongColumns}
        addClick1={AddClick1}
      />
    </div>
  );
}

export default WOR_BASIC_02F;
